// import ChatSupport from 'components/ChatSupport';
import LoadingIndicator from 'components/LoadingIndicator';
import Notification from 'components/Notification';
import { Viewport } from 'components/ViewportProvider';
// import FavoriteCategoryNav from 'containers/FavoriteCategoryNav';
import changeStorePageMessages from 'containers/ChangeStorePage/messages';
import { IMainLayoutDispatchProps, IMainLayoutStateProps } from 'containers/MainLayout/types';
import { isSupported } from 'firebase/messaging';
import React, { FC, ReactElement, Suspense, lazy, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import translations from 'translations';
import media from 'utils/mediaStyle';
import messages from 'utils/messages';
import { pathnameChecker } from 'utils/url';
import { onMessageListener } from '../firebase';
import AlcoholPopup from './AlcoholPopup/index';
import BreadCrumb from './BreadCrumb';
import { ErrorBoundary } from './ErrorBoundary';
import HolidayNotification from './HolidayNotification';
import TopNav from './MainNav/TopNav';
import TabPages from './TabPages';
import TagsNavBar from './TagsNavBar';

const Container = styled.div`
  background: #f9fafc;
  min-height: 100vh;

  ${({ isBgWhite }) =>
    isBgWhite &&
    `
    background: #ffffff;
  `}
`;
const Content = styled.section<any>`
  margin-left: 0;
  position: relative;
  flex-shrink: 1;
  flex-grow: 1;
  margin-bottom: 16px;
  background: #f9fafc;
  padding-top: 0;
  transition: margin-left 0.3s ease-in-out;
  min-height: calc(100vh - 160pt);
  width: 100%;

  ${media.md`
    padding: 0 10pt;
  `};
  ${media.lg`
    ${({ overflowVisible }) =>
      !overflowVisible &&
      `overflow-x: hidden;
   `}
  `};

  ${({ isHomePage }) =>
    isHomePage &&
    `
  @media (max-width: 576px) {
    margin-bottom: 0px;
  }
  `}

  ${({ addMarginTop }) =>
    addMarginTop &&
    `
  margin-top: 80.5pt; 
 `}
 
 ${({ bgWhite }) =>
    bgWhite &&
    `
    background: #ffffff;
  `}
`;

const MainContent = styled.div`
  max-width: 1200px;
  min-height: calc(100svh - 124px);
  margin: auto;
  position: relative;
  display: flex;
  @media (max-width: 1024px) {
    display: block;
  }
  ${({ isHomePage }) =>
    isHomePage &&
    `
  @media (max-width: 767px) {
    &:before {
      content: '';
      position: fixed;
      width: 100%;
      height: 400px;
      top: 0;
      left: 0;
      background: rgb(76, 175, 80);
      z-index: -1;
    }
  }
  `}
  ${({ isFullScreen }) =>
    isFullScreen &&
    `
    max-width: 100%;
    ${Content} {
      padding: 0;
    }
  `}
`;

const FooterWrapper = styled.div`
  background: #ffffff;
  padding: 0 10pt;
  min-height: 780px;
  width: 100%;
  @media (max-width: 1024px) {
    border-bottom: 72px solid transparent;
  }
  @media (max-width: 992px) {
    padding: 0;
  }
`;

const TopElementsWrapper = styled.div`
  & > div:first-child {
    margin-top: 99.66px;
    padding-top: 12px;

    ${media.md`
        margin-top: 105.66px;
      `};
  }
`;

const NoteForDisableStore = styled.div`
  padding: 10px;
  border-radius: 6px;
  background: #ffecea;
  font-size: 16px;
  margin-bottom: 0px;
  margin-top: 12px;
  font-weight: 400;
  @media (max-width: 1024px) {
    position: fixed;
    bottom: 90px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    z-index: 1000000;
    width: 93%;
  }
`;

type Props = IMainLayoutStateProps & IMainLayoutDispatchProps & RouteProps & RouteComponentProps;

const pathAbleDisplaySideNav = [
  '/orders',
  '/phieu-giao',
  '/orders-pending-approval',
  '/pending-orders-history',
  '/item-analysis',
  '/company-info',
  '/store-info',
  '/user-management',
  '/group-management',
  '/overview',
  '/account-info',
  '/account-mobile',
  '/user-details',
  '/groups',
];

const pathNotDisplayBreadCrumb = [
  '/',
  '/account-mobile',
  '/thuong-hieu-kamereo',
  '/thuong-hieu',
  '/he-thong-phan-phoi',
  '/nguyen-lieu-nhat-ban-gyomu-japan',
  '/not-authorized',
  '/not-found',
  '/tu-nong-trai-den-doanh-nghiep',
  '/lien-he-kamereo',
];

const pathsNameShouldShowFullScreen = ['/tu-nong-trai-den-doanh-nghiep', '/lien-he-kamereo'];

const pathNameWithBgWhite = ['/products'];

const ChatSupport = lazy(() => import(/* webpackPreload: true */ 'components/ChatSupport'));
const FooterComponent = lazy(() => import('components/Footer'));
const LazyModal = lazy(() => import('antd').then((module) => ({ default: module.Modal })));
const SideNavNewDesign = lazy(() => import('components/MainNav/SideNavNewDesign'));
const FavoriteCategoryNav = lazy(() => import('containers/FavoriteCategoryNav'));

const MainLayout: FC<Props> = (props) => {
  const {
    mainLayout: {
      buyer,
      store,
      sideNav,
      user,
      cart,
      notification,
      categories,
      hasUnreadNotification,
      isOpenAlcoholPopup,
      isUnder18,
      trendingSearchData,
    },
    children,
    setLang,
    signout,
    toggleSideNav,
    isPenddingApproval,
    countPendingOrder,
    registerNotificationToken,
    location,
    region,
    setSearchProductResults,
    clearSearchProductResults,
    fetchBuyerWebVersion,
    buyerWebVersion,
    checkBadword,
    handleSaveSearchKeyword,
  } = props;

  const FooterRef = useRef<ReactElement>(null);
  const [openModal, setOpenModal] = useState(false);
  const userPermissions = useMemo(() => {
    const permissions = (user.permissions || []).map((permission) => permission.action);
    (user.userGroups || []).forEach((group) => {
      group.permissions.forEach((permission) => {
        if (permissions.indexOf(permission.action) === -1) {
          permissions.push(permission.action);
        }
      });
    });
    return permissions;
  }, [user.permissions, user.userGroups]);
  const isBgWhite = pathNameWithBgWhite.some((path) => location.pathname.includes(path));

  useEffect(() => {
    (async () => {
      if (await isSupported()) {
        onMessageListener(buyer?.id, store?.id);
      }
    })();
    const sixHours = 21600000;
    const intervalId = setInterval(() => {
      fetchBuyerWebVersion();
    }, sixHours);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (buyerWebVersion) {
      const buyerVersionStorage = localStorage.getItem('buyer-version');
      if (!buyerVersionStorage) {
        localStorage.setItem('buyer-version', buyerWebVersion);
        return;
      }
      if (buyerVersionStorage !== buyerWebVersion) {
        setOpenModal(true);
      }
    }
  }, [buyerWebVersion]);
  return (
    <ErrorBoundary>
      <Container isBgWhite={isBgWhite}>
        <ErrorBoundary>
          <TopNav
            cart={cart}
            user={user}
            store={store}
            buyer={buyer}
            permissions={userPermissions}
            onToggle={toggleSideNav}
            onSignout={signout}
            onSetLang={setLang}
            opened={sideNav}
            categories={categories}
            hasUnreadNotification={hasUnreadNotification}
            setSearchProductResults={setSearchProductResults}
            clearSearchProductResults={clearSearchProductResults}
            checkBadword={checkBadword}
            handleSaveSearchKeyword={handleSaveSearchKeyword}
            trendingSearchData={trendingSearchData}
          />
        </ErrorBoundary>
        <Viewport.Consumer>
          {({ width }) => (
            <TopElementsWrapper>
              {width > 991 &&
                location.pathname !== '/' &&
                (pathnameChecker.isMarketRoutes(location.pathname) ||
                  pathnameChecker.isProductTagPage(location.pathname.slice(1))) && <TagsNavBar />}
              {!pathNotDisplayBreadCrumb.includes(location.pathname) && <BreadCrumb />}
            </TopElementsWrapper>
          )}
        </Viewport.Consumer>
        <Viewport.Consumer>
          {({ width }) => (
            <MainContent
              isHomePage={location.pathname === '/'}
              isFullScreen={pathsNameShouldShowFullScreen.includes(location.pathname)}
            >
              {location.pathname === '/favorite' && width > 1024 && (
                <ErrorBoundary>
                  <Suspense fallback={<LoadingIndicator />}>
                    <FavoriteCategoryNav />
                  </Suspense>
                </ErrorBoundary>
              )}
              {pathAbleDisplaySideNav.includes(
                location.pathname.lastIndexOf('/') === 0
                  ? location.pathname
                  : location.pathname.substring(0, location.pathname.lastIndexOf('/')),
              ) &&
                width > 1024 && (
                  <ErrorBoundary>
                    <Suspense fallback={<LoadingIndicator />}>
                      <SideNavNewDesign
                        opened={sideNav}
                        permissions={userPermissions}
                        store={store}
                        user={user}
                        onToggle={toggleSideNav}
                        isPenddingApproval={isPenddingApproval}
                        countPendingOrder={countPendingOrder}
                      />
                    </Suspense>
                  </ErrorBoundary>
                )}
              <Content
                addMarginTop={location.pathname === '/' || location.pathname === '/account-mobile'}
                isHomePage={location.pathname === '/'}
                overflowVisible={
                  [
                    '/thuong-hieu-kamereo',
                    '/nguyen-lieu-nhat-ban-gyomu-japan',
                    '/tu-nong-trai-den-doanh-nghiep',
                    '/lien-he-kamereo',
                  ].includes(location.pathname) || location.pathname.includes('/products/')
                }
                bgWhite={isBgWhite}
              >
                {pathAbleDisplaySideNav.includes(location.pathname) && (
                  <ErrorBoundary>
                    <TabPages permissions={userPermissions} isPendingApproval={isPenddingApproval} />
                  </ErrorBoundary>
                )}
                {location.pathname === '/' && store.status === 'BLOCKED' && (
                  <NoteForDisableStore>
                    <FormattedMessage {...changeStorePageMessages.noteForDisableStore} />
                  </NoteForDisableStore>
                )}
                {location.pathname === '/' && region && width > 1024 && <HolidayNotification region={region} />}
                <ErrorBoundary>{children}</ErrorBoundary>
              </Content>
            </MainContent>
          )}
        </Viewport.Consumer>
        <Suspense fallback={<LoadingIndicator />}>
          <ChatSupport />
        </Suspense>
        <FooterWrapper ref={FooterRef} id="footer-wrapper">
          <Suspense fallback={<LoadingIndicator />}>
            <FooterComponent />
          </Suspense>
        </FooterWrapper>
        <Notification
          userId={user.id}
          notificationId={notification.id}
          registerNotificationToken={registerNotificationToken}
        />
        {openModal && (
          <Suspense fallback={<LoadingIndicator />}>
            <LazyModal
              title={translations(messages.notice)}
              open={openModal}
              onOk={() => {
                localStorage.setItem('buyer-version', buyerWebVersion || '');
                window.location.reload();
                setOpenModal(false);
              }}
              okText={translations(messages.yes)}
              cancelText={translations(messages.no)}
              onCancel={() => setOpenModal(false)}
            >
              <FormattedMessage {...messages.reloadPageMessage} />
            </LazyModal>
          </Suspense>
        )}
        <AlcoholPopup open={isOpenAlcoholPopup} isUnder18={isUnder18} />
        {/* {!buyer.loading && !store.loading && store.isForceUpdate && <PopupConfirmStoreLocation buyer={buyer} />} */}
      </Container>
    </ErrorBoundary>
  );
};

export default withRouter(MainLayout);
